<template>
  <div>
    <page-header
      :page="page"
      :actions="pageActionConfig"
      left-side-class="col-xl-8"
      right-side-class="
        col-xl-4 align-items-end d-flex pb-2 justify-content-end
      "
    />

    <div class="rounded p-3 mb-3" style="background-color:#f2f2f2 ;">
      <div class="row rounded p-3 mx-1" style="background-color:#ffffff;">
        <div
          class="col-4 d-flex flex-column"
          :class="workshopDetail.title?.length > 25 ? 'col-12 mt-2' : 'col-3'"
        >
          <label class="text-muted">
            <i class="fas fa-file-alt text-orange mr-1"></i>
            Nombre del Taller:
          </label>
          <span>{{ workshopDetail.title | empty }}</span>
        </div>
        <div
          class="col-4 d-flex flex-column"
          :class="workshopDetail.title?.length > 25 ? 'col-6 mt-2' : 'col-3'"
        >
          <label class="text-muted">
            <i class="fas fa-calendar text-orange mr-1"></i>
            Fecha y Hora del Taller:
          </label>
          <span>
            {{ workshopDetail.startDate | dateTime }} -
            {{ workshopDetail.endDate | dateTime }}
          </span>
        </div>
        <div
          class="col-4 d-flex flex-column "
          :class="workshopDetail.title?.length > 25 ? 'col-6 mt-2' : 'col-3'"
        >
          <label class="text-muted">
            <i class="fas fa-calendar text-orange mr-1"></i>
            Período y Hora de Inscripción:
          </label>
          <span>
            {{ workshopDetail.enrollmentStartDate | dateTime }} -
            {{ workshopDetail.enrollmentEndDate | dateTime }}
          </span>
        </div>
      </div>
    </div>

    <filter-manager
      ref="filter"
      v-model="this.filter.model"
      :display-advanced="false"
      items-container-class="flex-wrap"
      actions-container-class="col-sm-3 ml-0 mr-0 text-right"
      :filters="filtersHeader"
      @search="() => onSearch()"
    />

    <custom-separator class="my-4" text="Resultados" />

    <div v-if="results.length > 0">
      <div class="mb-3" v-for="(item, index) in results">
        <participant-row
          :item="item"
          :index="index"
          :will-generate-certificate="workshopDetail.willGenerateCertificate"
          @save-absense="saveAbsence"
          @toggle="toggle"
        />
      </div>
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="onPageChanged"
      />
    </div>
    <div v-else>
      <custom-result-not-found />
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import CustomCallout from 'custom-callout';
import CustomInputDisplay from 'CustomInputDisplay';
import ActionButton from 'ActionButton';
import CustomBalloon from 'custom-balloon';
import Pagination from 'pagination';
import FilterManager from 'FilterManager';
import WorkshopStatus from '@/utils/constants/operations-dashboard-management/workshopStatuses';
import DropDown from 'dropdown';
import ParticipantRow from './ParticipantRow.vue';
import reportService from '@/services/report';
import alertMixin from '@/mixin/alert.mixin';

import {
  getAllWorkshopParticipants,
  getWorkshopDetail,
  getWorkshopStatuses,
  notifyWorkshopParticipantAbsence,
} from '@/services/operations/dashboard-management';

export default {
  name: 'DashboardMaintenanceManagementParticipants',
  mixins: [alertMixin],
  components: {
    PageHeader,
    CustomSeparator,
    CustomResultNotFound,
    CustomCallout,
    CustomInputDisplay,
    ActionButton,
    CustomBalloon,
    Pagination,
    FilterManager,
    DropDown,
    ParticipantRow,
  },
  data() {
    return {
      filter: {
        model: {
          status: null,
        },
        options: {
          statuses: [],
        },
      },
      workshopDetail: {},
      page: {
        icon: 'fas fa-users',
        title: 'Participantes',
        routes: [
          'Inicio',
          'Operaciones',
          'Mantenimiento de Dashboard',
          'Ver Participantes',
        ],
      },
      results: [],
      pagination: {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        totalItemCount: 0,
        pageSize: 10,
      },
    };
  },
  computed: {
    pageActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
        {
          text: 'Descargar Reporte',
          icon: 'fas fa-file-download',
          variant: 'success',
          click: () => this.downloadWorkshopParticipants(),
        },
      ];
    },
    filtersHeader() {
      return [
        {
          name: 'status',
          component: 'CustomDropDown',
          placeholder: 'Estatus',
          options: this.filter.options.statuses,
          value: this.filter.model.status,
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-lg-3',
          classContainer: 'w-100',
        },
        {
          name: 'fromDate',
          component: 'custom-date-picker',
          placeholder: 'Fecha Desde',
          class: 'col-12 col-lg-3',
        },
        {
          name: 'toDate',
          component: 'custom-date-picker',
          placeholder: 'Fecha Hasta',
          class: 'col-12 col-lg-3',
        },
        {
          name: 'searchText',
          component: 'CustomInput',
          placeholder: 'Escribir nombre de participante',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          type: 'text',
          class: 'col-12 col-lg-3',
        },
      ];
    },
  },
  async mounted() {
    await this.onSearch();
    await this.getWorkshopStatuses();
    const workshopId = this.$route.query.workshopId;
    if (workshopId) {
      this.getWorkshopDetail(workshopId);
    }
  },
  methods: {
    async getWorkshopStatuses() {
      const { data } = await getWorkshopStatuses();
      this.filter.options.statuses = data.filter(
        (status) => status.id !== WorkshopStatus.Available
      );
    },
    onPageChanged(page) {
      this.onSearch(page);
    },
    async onSearch(page = 1) {
      const payload = {
        postId: this.$route.params.id,
        fromDate: this.filter.model.fromDate,
        toDate: this.filter.model.toDate,
        statusId: this.filter.model.status?.id,
        keyword: this.filter.model.searchText,
        currentPage: page,
        pageSize: this.pagination.pageSize,
      };
      const { data } = await getAllWorkshopParticipants(payload);
      this.results = data.data.map((x) => ({ ...x, isOpen: false }));
      this.pagination = {
        ...this.pagination,
        count: data.count,
        currentPage: data.currentPage,
        pageCount: data.pageCount,
        totalItemCount: data.totalItemCount,
      };
    },
    async getWorkshopDetail(id) {
      const { data } = await getWorkshopDetail(id);
      this.workshopDetail = data;
    },
    async saveAbsence(payload) {
      try {
        await notifyWorkshopParticipantAbsence(payload);
        await this.onSearch(this.pagination.currentPage);
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
    toggle({ id }) {
      this.results
        .filter((x) => x.id !== id)
        .forEach((x) => (x.isOpen = false));
    },
    async downloadWorkshopParticipants() {
      const postId = this.$route?.params?.id;
      await reportService.downloadWorkshopParticipants(postId);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .custom-datetime-picker-container.width-container {
  width: 100% !important;
}
</style>
